import { Service } from '../types';

export const services: Service[] = [
  {
    id: 1,
    title: 'Virtual Styling',
    description: 'Perfect for clients who want professional design advice without an in-person visit. We\'ll review photos of your space and provide recommendations via video call.',
    price: '$150 per room',
    image: 'https://images.pexels.com/photos/1125135/pexels-photo-1125135.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 2,
    title: 'In-Person Consultation',
    description: 'Our designer visits your home for a comprehensive assessment, taking measurements and discussing your vision in detail.',
    price: '$250 for up to 2 hours',
    image: 'https://images.pexels.com/photos/1643384/pexels-photo-1643384.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 3,
    title: 'Color Palette Selection',
    description: 'Finding the perfect colors for your space can be challenging. Our experts will help you create a harmonious color scheme that reflects your personality.',
    price: '$120 per consultation',
    image: 'https://images.pexels.com/photos/1776574/pexels-photo-1776574.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 4,
    title: 'Full Room Redesign',
    description: 'Complete transformation of your space with furniture selection, layout planning, color schemes, and accessory recommendations.',
    price: 'Starting at $450 per room',
    image: 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  }
];